export const FF_PLANNING_NOTES = true;
export const FF_CHECKLIST = true;
export const FF_TRENDS = true;
// export const FF_FORECASTING = process.env.NODE_ENV !== 'production';
export const FF_FORECASTING = true; // TODO: remove hardcoded value
export const FF_INTEGRATION_ICONS = true;
